import { FullProfile, UsuarioFuncionalidade, VinculoUsuarioOperadora } from '@gestor-web/@core/api/ords/model';
import { UserProfileActions } from '@gestor-web/@core/store/actions';
import { createReducer, on } from '@ngrx/store';
import { vinculosDoWorkspace } from '../../auth/abrangencia';

export const featureKey = 'userProfile';

const REQUIRED_FIELDS = ['nr_cpf', 'ds_cargo', 'nr_fone_celular'];

export interface State extends FullProfile {
  kc_loaded: boolean;
  idss_loaded: boolean;
  loginClienteIdp: string;
  isEditing: boolean;
  isIncomplete: boolean;
  isOffline: boolean;
  operadorasVinculadas: VinculoUsuarioOperadora[];
  cookiesBannerShow: boolean;
  cookiesAcceptAll: boolean;
  funcionalidades: UsuarioFuncionalidade[];
  funcionalidades_loaded: boolean;
  /** Operadora da lista carregada (ou pedida); `null` é a lista só do papel, sem operadora. */
  funcionalidades_regans: string | null;
}

export const initialState: State = {
  kc: null,
  kc_loaded: false,
  idss: null,
  idss_loaded: false,
  loginClienteIdp: '',
  isEditing: false,
  isIncomplete: true,
  isOffline: false,
  operadorasVinculadas: [],
  cookiesBannerShow: false,
  cookiesAcceptAll: false,
  funcionalidades: [],
  funcionalidades_loaded: false,
  funcionalidades_regans: null,
};

export const reducer = createReducer(
  initialState,

  on(UserProfileActions.getKeycloakProfileSuccess, (state, { kc }) => {
    return {
      ...state,
      kc,
      kc_loaded: true,
    };
  }),

  on(UserProfileActions.getIdssProfileSuccess, (state, { idss, operadoras }) => {
    let isIncomplete = false;
    REQUIRED_FIELDS.forEach(field => {
      if (!idss[field]) isIncomplete = true;
    });

    return {
      ...state,
      idss,
      idss_loaded: true,
      isIncomplete,
      operadorasVinculadas: operadoras,
    };
  }),

  on(UserProfileActions.getFuncionalidades, (state, { regans }) => {
    return { ...state, funcionalidades_loaded: false, funcionalidades_regans: regans ?? null };
  }),

  on(UserProfileActions.getFuncionalidadesSuccess, (state, { funcionalidades }) => {
    return { ...state, funcionalidades, funcionalidades_loaded: true };
  }),

  on(UserProfileActions.getFuncionalidadesFailure, (state, { status, message }) => {
    console.warn('[UserProfile] erro ao carregar funcionalidades', status, message);
    // Sem resposta (timeout, rede) ou erro do servidor: página de serviço inacessível, não o app todo bloqueado.
    return { ...state, funcionalidades: [], funcionalidades_loaded: true, isOffline: !status || status >= 500 };
  }),

  on(UserProfileActions.getIdssProfileFailure, (state, { status, message }) => {
    console.warn('[UserProfile] error', status, message);
    return { ...state, idss: null, idss_loaded: true, isIncomplete: status >= 400, isOffline: !status };
  }),

  on(UserProfileActions.salvarDadosComplementaresSuccess, (state, { idss }) => {
    return {
      ...state,
      idss,
      idss_loaded: true,
      isEditing: false,
      isIncomplete: false,
      isOffline: false,
      operadorasVinculadas: vinculosDoWorkspace(idss),
    };
  }),

  on(UserProfileActions.completarCadastro, state => {
    return { ...state, isEditing: true };
  }),

  on(UserProfileActions.editarCadastro, state => {
    return { ...state, isEditing: true };
  }),

  on(UserProfileActions.cancelarEditarCadastro, state => {
    return { ...state, isEditing: false };
  }),

  on(UserProfileActions.cookiesConsentUpdate, (state, { showBanner, acceptAll }) => {
    return { ...state, cookiesBannerShow: showBanner, cookiesAcceptAll: acceptAll };
  }),

  on(UserProfileActions.loginClienteIdpUpdate, (state, { loginClienteIdp }) => {
    return { ...state, loginClienteIdp };
  }),
);
